import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { lazyGettext } from '@eb/lazy-gettext';
import gettext from '@eb/gettext';
import { translationPropType } from '@eb/i18n';
import { IconButton } from '@eb/eds-icon-button';
import { InputField } from '@eb/eds-input-field';
import { TYPE_SUBMIT } from '@eb/eds-button';
import { DEFAULT_SEARCH_QUERY } from './constants';

import { MagnifyingGlassChunky } from '@eb/eds-iconography';
import { CrossChunky } from '@eb/eds-iconography';

export default class SearchFilter extends PureComponent {
    static propTypes = {
        /**
         * Initial search filter
         */
        searchQuery: PropTypes.string,
        /**
         * Function called when new filter is chosen
         */
        onFilter: PropTypes.func,
        /**
         * Function called with every keypress change of filter
         */
        onChange: PropTypes.func,
        /**
         * ID of search field
         */
        inputId: PropTypes.string,
        /**
         * Hidden label of search field
         */
        inputLabel: translationPropType,
        /**
         * Search field place holder
         */
        inputPlaceholder: PropTypes.string,
    };

    static defaultProps = {
        searchQuery: DEFAULT_SEARCH_QUERY,
        inputId: 'search-filter-form',
        inputLabel: lazyGettext('Search'),
    };

    constructor(props) {
        super(props);

        this.state = {
            searchQuery: props.searchQuery,
            isSearchFocused: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ searchQuery: nextProps.searchQuery });
    }

    _submitFilters = () => {
        const { searchQuery } = this.state;
        const { onFilter } = this.props;

        if (onFilter) {
            onFilter({
                searchQuery,
            });
        }
    };

    _handleSubmit = (e) => {
        e.preventDefault();

        this._submitFilters();
    };

    _handleSearchChange = (searchQuery) => {
        const { onChange } = this.props;

        this.setState({ searchQuery });

        if (onChange) {
            onChange({ searchQuery });
        }
    };

    _handleSearchBlur = () => {
        this.setState({ isSearchFocused: false });
    };

    _handleSearchFocus = () => {
        this.setState({ isSearchFocused: true });
    };

    _handleSearchClear = () => {
        this.setState(
            {
                searchQuery: '',
                isSearchFocused: true,
            },
            this._submitFilters,
        );
    };

    render() {
        const { inputId, inputLabel, inputPlaceholder } = this.props;
        const { searchQuery, isSearchFocused } = this.state;
        const submitSearchButton = (
            <IconButton
                data-spec="search-submit-button"
                iconType={<MagnifyingGlassChunky />}
                title={inputLabel}
                type={TYPE_SUBMIT}
            />
        );
        let clearSearchButton;

        if (searchQuery) {
            clearSearchButton = (
                <IconButton
                    data-spec="search-clear-button"
                    iconType={<CrossChunky />}
                    title={gettext('Clear search')}
                    onClick={this._handleSearchClear}
                />
            );
        }

        return (
            <form onSubmit={this._handleSubmit} data-spec="search-filter-form">
                <InputField
                    value={searchQuery}
                    style="basic"
                    prefix={submitSearchButton}
                    suffix={clearSearchButton}
                    id={inputId}
                    data-spec="search-filter-input"
                    label={inputLabel}
                    placeholder={inputPlaceholder}
                    hasMinAsideSpacing={true}
                    autoComplete="off"
                    onChange={this._handleSearchChange}
                    onBlur={this._handleSearchBlur}
                    onFocus={this._handleSearchFocus}
                    shouldFocus={isSearchFocused}
                />
            </form>
        );
    }
}
